import React, { useState, useEffect } from "react";
import axios from "axios";
import API_URL from "../../ApiUrl";
import Swal from "sweetalert2";
import ReCAPTCHA from "react-google-recaptcha";
import { useParams } from "react-router-dom";

const DetailLowongan = () => {
    const { slug } = useParams();

    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [captcha, setCaptcha] = useState("");
    const [errors, setErrors] = useState([]);
    const [dataLowongan, setDataLowongan] = useState(null);
    const [provinsi, setProvinsi] = useState([]);
    const [kabkotaCurrent, setKabkotaCurrent] = useState([]);
    const [kabkotaKtp, setKabkotaKtp] = useState([]);

    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        no_hp: "",
        place_birth: "",
        date_birth: "",
        gender: "",
        maried: "",
        religion: "",
        address: "",
        id_current_province: "",
        id_ktp_province: "",
        current_province: "",
        current_city: "",
        current_subdistrict: "",
        current_kode_post: "",
        ktp_addres: "",
        ktp_province: "",
        ktp_city: "",
        ktp_subdistrict: "",
        ktp_kode_post: "",
        instagram: "",
        linkedin: "",
        emergency_name: "",
        emergency_phone: "",
        text_promosi_diri: "",
        file_cv: "",
        file_cv_name: "",
        file_ijazah: "",
        file_ijazah_name: "",
        file_english: "",
        file_english_name: "",
    });

    const handleCaptcha = (val) => setCaptcha(val);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFile = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;
        setFormData((prev) => ({
            ...prev,
            [type]: file,
            [`${type}_name`]: file.name,
        }));
    };

    const handleChangeProvince = async (e, type) => {
        const { name, value } = e.target;
        const selectedProvince = provinsi.find((p) => p.id == value);
        const provinceName = selectedProvince ? selectedProvince.province_name : "";

        setFormData((prev) => ({
            ...prev,
            [name]: value,
            ...(type === "current"
                ? { current_province: provinceName }
                : { ktp_province: provinceName }),
        }));

        await getKabkotaByProvince(value, type);
    };

    const getKabkotaByProvince = async (id_province, type) => {
        try {
            const res = await axios.get(
                `${API_URL.superStudent2}/master/kabupaten/${id_province}`
            );
            if (type === "current") setKabkotaCurrent(res.data.data);
            else setKabkotaKtp(res.data.data);
        } catch (err) {
            console.log(err);
        }
    };

    const getDetailLowongan = async () => {
        try {
            const res = await axios.get(
                `${API_URL.superStudent2}/niec-career/detail-lowongan/${slug}`
            );
            setDataLowongan(res.data.data);
        } catch (err) {
            console.log(err);
        }
    };

    const getProvinsi = async () => {
        try {
            const res = await axios.get(`${API_URL.superStudent2}/master/provinces`);
            setProvinsi(res.data.data);
        } catch (err) {
            console.log(err);
        }
    };

    const formatRupiah = (nominal) =>
        new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
        }).format(nominal);

    const applyKandidat = async (e) => {
        e.preventDefault();
        setBtnLoading(true);
        setBtnDisabled(true);

        const data = new FormData();
        Object.entries(formData).forEach(([key, val]) => {
            data.append(key, val);
        });

        data.append("job_vacancy", dataLowongan?.title);
        data.append("id_job_vacancy", dataLowongan?.id_job_vacancy);

        try {
            await axios.post(
                `${API_URL.superStudent2}/niec-career-candidate/add`,
                data,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.fire({
                title: "Berkas Lamaran Anda Telah Terkirim",
                icon: "success",
                confirmButtonColor: "#3085d6",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        } catch (err) {
            setErrors(err.response?.data?.data || {});
            console.log(err.response?.data?.data);
        } finally {
            setBtnLoading(false);
            setBtnDisabled(false);
        }
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        getDetailLowongan();
        getProvinsi();
    }, []);

    return (
        <>
            <section className='career'>
                <div className="bg-career detail-job">
                    <h4 className='job-title'>{dataLowongan?.title}</h4>
                </div>
                <div className="container content-detail-lowongan">
                    <div className="row">
                        <div className="col-lg-12 d-flex justify-content-center">
                            <h1>{dataLowongan?.title}</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 d-flex justify-content-center">
                            <p className='kat'>
                                <i className="bi bi-briefcase"></i> {dataLowongan?.department} <span>|</span> <i className="bi bi-geo-alt"></i> {dataLowongan?.propinsi?.nama_kabkota} <span></span>
                                {dataLowongan?.gaji_1 === null ? '' :
                                    (<><span>|</span> <i className='bi bi-currency-exchange'></i> {formatRupiah(dataLowongan?.gaji_1)} </>)}
                                {dataLowongan?.gaji_2 === null ? '' : '- ' + formatRupiah(dataLowongan?.gaji_2)}
                            </p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-lg-12 d-flex justify-content-center">
                            <div dangerouslySetInnerHTML={{ __html: dataLowongan?.deskripsi }} />
                        </div>
                    </div>
                    <div className='row mt-5 d-flex justify-content-center'>
                        <div className="col-lg-11">
                            <div className="form-card">
                                <h4>Apply Your Resume</h4>
                                <form onSubmit={(e) => applyKandidat(e)}>
                                    <div className='row'>
                                        <div className='col'>
                                            <span>First Name</span>
                                            <input type="text" name='first_name' onChange={(e) => handleChange(e)} className={`form-control ${errors?.first_name ? 'is-invalid' : ''}`} id="first_name" />
                                            <div className="invalid-feedback">{errors?.first_name}</div>
                                        </div>
                                        <div className='col'>
                                            <span>Last Name</span>
                                            <input type='text' name='last_name' onChange={(e) => handleChange(e)} className={`form-control ${errors?.last_name ? 'is-invalid' : ''}`} id="last_name" />
                                            <div className="invalid-feedback">{errors?.last_name}</div>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col'>
                                            <span>Phone Number (WA)</span>
                                            <input type='number' name='no_hp' onChange={(e) => handleChange(e)} className={`form-control ${errors?.no_hp ? 'is-invalid' : ''}`} id="no_hp" />
                                            <div className="invalid-feedback">{errors?.no_hp}</div>
                                        </div>
                                        <div className='col'>
                                            <span>Email</span>
                                            <input type='text' name='email' onChange={(e) => handleChange(e)} className={`form-control ${errors?.email ? 'is-invalid' : ''}`} id="email" />
                                            <div className="invalid-feedback">{errors?.email}</div>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col'>
                                            <span>Place Birth</span>
                                            <input type='text' name='place_birth' onChange={(e) => handleChange(e)} className={`form-control ${errors?.place_birth ? 'is-invalid' : ''}`} id="place_birth" />
                                            <div className="invalid-feedback">{errors?.place_birth}</div>
                                        </div>
                                        <div className='col'>
                                            <span>Date Birth</span>
                                            <input type='date' name='date_birth' onChange={(e) => handleChange(e)} className={`form-control ${errors?.date_birth ? 'is-invalid' : ''}`} id='date_birth' />
                                            <div className="invalid-feedback">{errors?.date_birth}</div>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-lg-3'>
                                            <span>Gender</span>
                                            <select name='gender' onChange={(e) => handleChange(e)} className={`form-control ${errors?.gender ? 'is-invalid' : ''}`} id='gender'>
                                                <option value={''}>--Choose One--</option>
                                                <option value={'L'}>Men</option>
                                                <option value={'P'}>Woman</option>
                                            </select>
                                            <div className="invalid-feedback">{errors?.gender}</div>
                                        </div>
                                        <div className='col-lg-3'>
                                            <span>Maried</span>
                                            <select name='maried' onChange={(e) => handleChange(e)} className={`form-control ${errors?.maried ? 'is-invalid' : ''}`} id='maried'>
                                                <option value={''}>--Choose One--</option>
                                                <option value={'S'}>Single</option>
                                                <option value={'M'}>Maried</option>
                                            </select>
                                            <div className="invalid-feedback">{errors?.maried}</div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <span>Religion</span>
                                            <select name='religion' onChange={(e) => handleChange(e)} className='form-control' id='religion'>
                                                <option>--Choose One--</option>
                                                <option value={'1'}>Moeslem</option>
                                                <option value={'2'}>Khatolik</option>
                                                <option value={'3'}>Christian</option>
                                                <option value={'4'}>Hindi</option>
                                                <option value={'5'}>Buddha</option>
                                                <option value={'6'}>Others</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-lg-6'>
                                            <span>Current Address</span>
                                            <textarea name='address' onChange={(e) => handleChange(e)} className={`form-control ${errors?.address ? 'is-invalid' : ''}`} style={{ height: '110px', resize: 'none' }} id='address'></textarea>
                                            <div className="invalid-feedback">{errors?.address}</div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className='row'>
                                                <div className='col-lg-6'>
                                                    <span>Province</span>
                                                    <select name='id_current_province' onChange={(e) => handleChangeProvince(e, 'current')} className={`form-control ${errors?.id_current_province ? 'is-invalid' : ''}`} id='id_current_province'>
                                                        <option value={''}>--Choose One--</option>
                                                        {
                                                            provinsi.map((provin, id) => (
                                                                <option key={id} value={provin.id}>{provin.province_name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <div className="invalid-feedback">{errors?.current_province}</div>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <span>City</span>
                                                    <select name='current_city' onChange={(e) => handleChange(e)} className={`form-control ${errors?.current_city ? 'is-invalid' : ''}`} id='current_city'>
                                                        <option value={''}>--Choose One--</option>
                                                        {
                                                            kabkotaCurrent.map((kabkota, id) => (
                                                                <option key={id} value={kabkota.kabupaten_name}>{kabkota.kabupaten_name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <div className="invalid-feedback">{errors?.current_city}</div>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-6'>
                                                    <span>Subdistrict</span>
                                                    <input name='current_subdistrict' className='form-control' type='text' onChange={(e) => handleChange(e)} id='kecamatan' />
                                                </div>
                                                <div className='col-lg-6'>
                                                    <span>Post Code</span>
                                                    <input name='current_kode_post' className='form-control' type='text' onChange={(e) => handleChange(e)} id='current_kode_post' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-lg-6'>
                                            <span>ID Card Address</span>
                                            <textarea name='ktp_addres' onChange={(e) => handleChange(e)} className='form-control' style={{ height: '110px', resize: 'none' }}></textarea>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className='row'>
                                                <div className='col-lg-6'>
                                                    <span>Province</span>
                                                    <select name='id_ktp_province' onChange={(e) => handleChangeProvince(e, 'ktp')} className='form-control' id='id_ktp_province'>
                                                        <option value={''}>--Choose One--</option>
                                                        {
                                                            provinsi.map((provin, id) => (
                                                                <option key={id} value={provin.id}>{provin.province_name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <span>City</span>
                                                    <select name='ktp_city' onChange={(e) => handleChange(e)} className='form-control' id='ktp_city'>
                                                        <option value={''}>--Choose One--</option>
                                                        {
                                                            kabkotaKtp.map((kabkota, id) => (
                                                                <option key={id} value={kabkota.kabupaten_name}>{kabkota.kabupaten_name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-6'>
                                                    <span>Subdistrict</span>
                                                    <input name='ktp_subdistrict' type='text' onChange={(e) => handleChange(e)} className='form-control' id='ktp_subdistrict' />
                                                </div>
                                                <div className='col-lg-6'>
                                                    <span>Post Code</span>
                                                    <input name='ktp_kode_post' type='text' onChange={(e) => handleChange(e)} className='form-control' id='ktp_kode_post' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-lg-6'>
                                            <span>Instagram (Username / Link)</span>
                                            <input name='instagram' type='text' onChange={(e) => handleChange(e)} className='form-control' id='instagram' />
                                        </div>
                                        <div className='col-lg-6'>
                                            <span>Linkedin (Username / Link)</span>
                                            <input name='linkedin' type='text' onChange={(e) => handleChange(e)} className='form-control' id='linkedin' />
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-lg-6'>
                                            <span>Emergency Contact (Name)</span>
                                            <input name='emergency_name' type='text' onChange={(e) => handleChange(e)} className='form-control' id='emergency_name' />
                                        </div>
                                        <div className='col-lg-6'>
                                            <span>Emergency Contact (Phone / WA)</span>
                                            <input name='emergency_phone' type='text' onChange={(e) => handleChange(e)} className='form-control' id='emergency_phone' />
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-lg-4'>
                                            <span>Upload Certivicate</span>
                                            <input type="file" name='file_ijazah' onChange={(e) => handleFile(e, 'file_ijazah')} className={`form-control ${errors?.file_ijazah ? 'is-invalid' : ''}`} />
                                            <div className="invalid-feedback">{errors?.file_ijazah}</div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <span>Upload CV</span>
                                            <input type="file" name='file_cv' onChange={(e) => handleFile(e, 'file_cv')} className={`form-control ${errors?.file_cv ? 'is-invalid' : ''}`} id="file_cv" placeholder='File CV' />
                                            <div className="invalid-feedback">{errors?.file_cv}</div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <span>Upload Englist Test</span>
                                            <input type="file" name='file_english_test' onChange={(e) => handleFile(e, 'file_english')} className="form-control" id="file_english_test" placeholder='File English Test' />
                                            <div className="invalid-feedback">{errors?.file_english_test}</div>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-lg-6'>
                                            <span>Describe Your Self</span>
                                            <textarea name="text_promosi_diri" className='form-control' id="" rows={5} onChange={(e) => handleChange(e)}></textarea>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-lg-6'>
                                            <ReCAPTCHA
                                                sitekey="6LcDiyIpAAAAAEUwQ9U7iOxiJKVO53AFx3qHN1HK"
                                                onChange={(val) => handleCaptcha(val)}
                                            />
                                        </div>
                                        <div className='col-lg-6 d-flex justify-content-end'>
                                            <button disabled={(btnDisabled && true) || (!captcha && true)} className='btn btn-success mt-3'>{btnLoading ? 'Applying...' : 'Apply'}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default DetailLowongan;